import React from "react";
import styles from "./Page2.module.scss";

import getstarted from "../../../Components copy/assets/Images/getstarted.svg";

export default function Page2() {
  return (
    <div className={styles.mainWrapper}>
      <div className={styles.topSection}>
        <p className={styles.headingText1}>Grow your Financial Business with</p>
        <p className={styles.headingText}>Firstock Partners</p>
        <p className={styles.subText}>
          Fostering prosperity for all, one partnership at a time.
        </p>
        {/* <div className={styles.getStartedText}>
          <img
            src={getstarted}
            onClick={() => {
              window.open("https://partner.thefirstock.com/", "_blank");
            }}
          />
        </div> */}
      </div>
      <div className={styles.leftContainer}>
        <video
          autoPlay={true}
          loop
          muted
          playsInline
          className={styles.videoMobileView}
        >
          <source
            src="https://firstock-common.s3.ap-south-1.amazonaws.com/projects/partnersignup/partnercontainer.mp4"
            type="video/mp4"
          />
        </video>
      </div>
    </div>
  );
}
